const alertDialogStyle = {
  baseStyle: {
    background: 'background',
  },
}

export default alertDialogStyle
